// @flow
import * as React from 'react';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import { injectIntl, IntlShape } from 'react-intl';
import point11Messages from 'esm-web-pro/messages/points11Messages';
import attributeMessages from 'esm-web-pro/messages/attributeMessages';
import { memoize } from 'lodash';

type Props = {
    dataPort: Object,
    url: string,
    intl: IntlShape,
    onView: Function,
}


const DataPortAttributes = (props: Props) => {
    const {
        dataPort, url, intl: { formatMessage }, onView,
    } = props;

    const {
        container, container: { container: point11 },
        data_port_number: portNumber, code,
    } = dataPort;


    const getCapabilities = memoize(() => {
        const {
            capable_100M: capable100M, capable_1G: capable1G, capable_10G: capable10G, capable_40G: capable40G,
        } = dataPort;

        const capabilitiesArr = [];

        if (capable100M) {
            capabilitiesArr.push(formatMessage(attributeMessages.capable100M));
        }
        if (capable1G) {
            capabilitiesArr.push(formatMessage(attributeMessages.capable1G));
        }
        if (capable10G) {
            capabilitiesArr.push(formatMessage(attributeMessages.capable10G));
        }
        if (capable40G) {
            capabilitiesArr.push(formatMessage(attributeMessages.capable40G));
        }

        return capabilitiesArr.length < 1 ? formatMessage(attributeMessages.noCapabilities)
            : capabilitiesArr.join(', ');
    });

    const attributes = [
        {
            label: formatMessage(attributeMessages.ref),
            value: dataPort.code,
            onClick: onView,
        },
        {
            label: formatMessage(attributeMessages.container),
            multiValue: [
                {
                    value: `${formatMessage(point11Messages[point11.type])} ${
                        point11.type === 'pop' && point11.alias
                            ? point11.alias
                            : point11.sequence
                    }`,
                    link: `${url.split('/layer')[0]}/layer/${point11.type}/${point11.identity}`,
                },
                {
                    value: container.oss_switch_name,
                    link: `${url.split('/layer')[0]}/layer/${container.type}/${container.identity}`,
                },
            ],
            separator: ', ',
        },
        {
            label: formatMessage(attributeMessages.capabilities),
            value: `${getCapabilities()}`,
        },
        {
            label: formatMessage(attributeMessages.OSS),
            value: `${container.oss_switch_name ? container.oss_switch_name : ''} ${portNumber} ${code || ''}`,
            customLink: `${process.env.REACT_APP_OSS_BASE_PATH}/switch/${container.id}/port/${portNumber}`,
        },
    ];

    return <Attributes attributes={attributes} />;
};

export default injectIntl(DataPortAttributes);
